module.exports = __webpack_public_path__ + "static/media/GREASE_FILTER.a659943a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/GREASE_FILTER.png
// module id = 669
// module chunks = 0